import request from '@/utils/request';
import { getPlayParams } from '@/utils/utils';

// 剩余抽奖次数
export function qryPlayChancesDXP(gameCode) {
  return request(`/promotion-rest-boot/dxp/game/v1/${gameCode}/remaining-play-chances`, {
    method: 'GET',
  });
}

// 抽奖
export function toPlayDXP(data) {
  return request('/promotion-rest-boot/dxp/game/v1/game/play', {
    method: 'POST',
    data,
  });
}

// 查询奖品详情DXP
export function getRewardMemDetailDXP(rewardInstanceId) {
  return request(`/promotion-rest-boot/dxp/game/v1/reward-instance/${rewardInstanceId}`, {
    method: 'GET',
  });
}

export function getMyAchieveRewardsDXP(params) {
  return request('/promotion-rest-boot/dxp/game/v1/reward-instance/history', {
    method: 'GET',
    params,
  });
}

// 大转盘通过奖品中心领取奖品
export function claimRewardDXP(data) {
  return request('/promotion-rest-boot/dxp/game/v1/reward-instance/claim', {
    method: 'POST',
    data,
  });
}

// 大转盘九宫格活动详情
export function qryLuckyDrawDetailWheelDXP(gameCode) {
  return request(`/promotion-rest-boot/dxp/game/v1/game/${gameCode}/detail`, {
    method: 'GET',
  });
}

// 签到活动详情
export function qryLuckyDrawDetailSignDXP(gameCode) {
  return request(`/promotion-rest-boot/dxp/game/v1/daily-check-in/${gameCode}`, {
    method: 'GET',
  });
}

// 锦鲤夺宝活动详情
export function qryLuckyDrawDetailKOIDXP(gameCode) {
  return request(`/promotion-rest-boot/dxp/game/v1/grand-raffle-game/${gameCode}`, {
    method: 'GET',
  });
}

// 分享活动详情
export function qryLuckyDrawDetailReferralDXP(gameCode) {
  return request(`/promotion-rest-boot/dxp/game/v1/referral-game/${gameCode}`, {
    method: 'GET',
  });
}

export function getPromotionLuckyDrawRuleDXP(gameCode) {
  return request(`/promotion-rest-boot/dxp/game/v1/${gameCode}/rules`, {
    method: 'GET',
  });
}

// 活动中奖用户列表
export function getAchieveRecordsDXP(gameCode) {
  return request(`/promotion-rest-boot/dxp/game/v1/${gameCode}/winners`, {
    method: 'GET',
  });
}

// 生成短链接口
export function batchCreateUtmLink(data) {
  return request('/promotion-rest-boot/promotion/utm/batchCreateUtmLink', {
    method: 'POST',
    data,
  });
}

// 积分兑换抽奖次数DXP
export function reducePointGetChancesDXP(data) {
  return request('/promotion-rest-boot/dxp/game/v1/play-chances/exchange', {
    method: 'POST',
    data: getPlayParams(data),
  });
}

export function qryUserInfo(params) {
  return request('/promotion-rest-boot/uc/user/info', {
    method: 'GET',
    params,
  });
}

// 通过token查询用户信息数据DXP
export function qryUserInfoDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/user/info', {
    method: 'GET',
    params,
  });
}
// 获取国内长途前缀接口
export function qryNationalPrefix(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/common/national-prefix', {
    method: 'GET',
    params,
  });
}

export function qryBalanceOfPointsDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/points/balance', {
    method: 'GET',
    params,
  });
}

// 查询appCode promotion/qryAppCode
export function qryAppCode() {
  return request('/promotion-rest-boot/promotion/qryAppCode', {
    method: 'POST',
  });
}

// 积分兑换抽奖次数重试DXP
export function reducePointGetChancesRetryDXP(data) {
  return request('/promotion-rest-boot/dxp/game/v1/play-chances/exchangeRetry', {
    method: 'POST',
    data,
  });
}

// eshop通过token获取用户信息
export function qryEshopUser(data) {
  return request('/promotion-rest-boot/promotion/luckyDraw/eShop/qry-eshop-user', {
    method: 'POST',
    data,
  });
}

// 获取配置项
export function getConfigParam(data) {
  return request('/promotion-rest-boot/promotion/getConfig', {
    method: 'POST',
    data,
  });
}

// 批量获取配置项
export function getConfigParamBatch(data) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/common/configs/batch', {
    method: 'POST',
    data,
  });
}

// 查询配置项
export function qryConfigItemParamValueByCode(data) {
  return request('/promotion-rest-boot/promotion/qryConfigItemParamValueByCode', {
    method: 'POST',
    data,
  });
}

// 获取谷歌埋点上报配置
export function getGAReportConfig() {
  return request('/promotion-rest-boot/dxp/loyalty/v1/common/ga-report-config', {
    method: 'GET',
  });
}

// 积分转账接口
export function pointTransferDXP(data) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/points/transfer', {
    method: 'POST',
    data,
  });
}

// 积分转账单笔最大限制
export function pointTransferLimits(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/common/transaction/limits', {
    method: 'GET',
    params,
  });
}

// 查询用户券实例
export function qryVoucherListDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/coupon-instance/history', {
    method: 'GET',
    params,
  });
}

// 查询主题
export function qryThemesLatest(params) {
  return request('/promotion-rest-boot/dxp/theme-management/v1/themes/latest', {
    method: 'GET',
    params,
  });
}

export function qryApiSgAuthToken(data) {
  return request('/api/sg/v2/oauth/token', {
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

// 查询用户短链内容
export function getUtmLink(id) {
  return request(`/dxp/loyalty/v1/utm/${id}`, {
    method: 'GET',
  });
}

// gcp静态
export function getLocalI18n(appCode) {
  return request(`${window.localStorage.getItem('prefixJson')}i18n/app/${appCode}/local.json`, {
    method: 'GET',
  });
}
// game 动态
export function getGameI18n(promotionId) {
  return request(
    `${window.localStorage.getItem('prefixJson')}i18n/5/GCP/GAME/${promotionId}/game.json`,
    {
      method: 'GET',
    },
  );
}

export function qryDefaultConfig() {
  let publicPath = '';
  if (process.env.NODE_ENV === 'production') {
    if (process.env.CONFIG_PUBLIC_PATH) {
      publicPath = process.env.CONFIG_PUBLIC_PATH;
    }
  }
  return request(`${publicPath}/defaultConfig.json?v=${Date.now()}`);
}
